import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/provide/common.service';

@Component({
  selector: 'app-service-provider-request-services',
  templateUrl: './service-provider-request-services.component.html',
  styleUrls: ['./service-provider-request-services.component.scss']
})
export class ServiceProviderRequestServicesComponent implements OnInit {

  btn: any = "Pending"
  orderList: any
  count: any
  catName: any
  currentPage: any = 1;
  pageSize: any = 10;
  serviceStatus: any = 'PENDING'
  notFoundData:boolean =false
  headingName:any ='My Bookings'
  linkerRouteItems:any =[
    { name:'Home',route: '/service-order-detail'},
    {name:'Account',route:'/customer-profile'},
    {name:'Bookings',route:'/service-provider-request-services'}
  ]
  constructor(public commonService: CommonService, public router: Router) { }

  ngOnInit(): void {
    this.serviceOrderList();
  }

  selectBtn(status) {
    this.btn = status;
    if (this.btn == 'Pending') {
      this.serviceStatus = 'PENDING';
      this.serviceOrderList();
    } else {
      this.serviceStatus = 'ACCEPTED';
      this.serviceOrderList();
    }
  }
  getPrice(e: any) {
    return this.commonService.getPrice(e)
  }
  
  /**
   * Format the service status in a user-friendly way
   * @param status The service status from the API
   * @returns Formatted service status string
   */
  formatServiceStatus(status: string): string {
    if (!status) return 'PENDING';
    
    switch(status.toUpperCase()) {
      case 'PENDING': return 'PENDING';
      case 'BOOKING_RECEIVED': return 'BOOKING RECEIVED';
      case 'ONTHEWAY': return 'ON THE WAY';
      case 'EXECUTION': return 'IN PROGRESS';
      case 'COMPLETED': return 'COMPLETED';
      case 'CANCELLED': return 'CANCELLED';
      default: return status.toUpperCase();
    }
  }
  
  /**
   * Get CSS class for service status styling
   * @param status The service status from the API
   * @returns CSS class for styling
   */
  getServiceStatusClass(status: string): string {
    if (!status) return 'status-pending';
    
    status = status.toUpperCase();
    if (status === 'PENDING') return 'status-pending';
    if (status === 'BOOKING_RECEIVED') return 'status-confirmed';
    if (status === 'ONTHEWAY') return 'status-ontheway';
    if (status === 'EXECUTION') return 'status-execution';
    if (status === 'COMPLETED') return 'status-completed';
    if (status === 'CANCELLED') return 'status-cancelled';
    
    return 'status-default';
  }
  
  /**
   * Get CSS class for payment status styling
   * @param status The payment status from the API
   * @returns CSS class for styling
   */
  getPaymentStatusClass(status: string): string {
    if (!status) return 'status-pending';
    
    status = status.toUpperCase();
    if (status === 'PENDING') return 'status-pending';
    if (status === 'PAID') return 'status-completed';
    if (status === 'FAILED') return 'status-cancelled';
    if (status === 'REFUNDED') return 'status-default';
    
    return 'status-default';
  }
  
  /**
   * Format the booked date and time in a user-friendly way
   * @param date The booking creation date
   * @returns Formatted date and time string
   */
  formatBookedDateTime(date: any): string {
    if (!date) return '--';
    
    const formattedDate = new Date(date).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
    
    const formattedTime = new Date(date).toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
    
    return `${formattedDate} ${formattedTime}`;
  }
  
  /**
   * Format the service date and time in a user-friendly way
   * @param date The service date
   * @param slot The time slot string or array (e.g. "9:00AM - 10:00AM")
   * @returns Formatted date and time string
   */
  formatServiceDateTime(date: any, slot: any): string {
    if (!date) return '--';
    
    const formattedDate = new Date(date).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
    
    // Handle case when slot is an array
    let slotValue = '';
    if (slot) {
      if (Array.isArray(slot)) {
        slotValue = slot.length > 0 ? slot[0] : '';
      } else {
        slotValue = slot;
      }
    }
    
    return `${formattedDate} ${slotValue}`;
  }
  
  isLoading:boolean =false
  serviceOrderList() {
    this.isLoading =true;
    this.orderList =[]
    this.count =0;
    const data = {
      page: this.currentPage,
      limit: this.pageSize,
      orderType: 'SERVICE',
      statusType: this.serviceStatus
    }
    this.commonService.postApi('v2/service/serviceOrderlist', data, 1).subscribe((res: any) => {
      this.isLoading =false
      if (res['responseCode'] == 200) {
        this.commonService.successToast(res['responseMessage'])
        this.commonService.hideSpinner()
        this.orderList = res.result.docs;
        if(res.result.docs.length>0){
          this.notFoundData =false
        }else{
          this.notFoundData =true
        }
        this.count = res.count
        this.catName = res.result.docs.myOrders[0]
      }

    }, (err: any) => {
      this.isLoading =false
      this.notFoundData =true
      if (err.responseCode == 409) {
        this.commonService.hideSpinner()
        this.commonService.errorToast(err.responseMessage)
      }
    })
  }

  changePageNumber(page) {
    this.currentPage = page;
    this.serviceOrderList();
  }
}
